import {useQuery} from 'react-query'
import {verifyHash, GoriSignatureResponse} from '../core/_requests'

export function useVerifyHash(hash: string | undefined) {
  return useQuery<GoriSignatureResponse, Error>(['gori-signature', hash], () => verifyHash(hash!), {
    enabled: !!hash,
    retry: false,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
